import {Dispatcher} from 'flux';

export const AuthenticationDispatcher = new Dispatcher();

export const doDispatch = function(action) {
    AuthenticationDispatcher.dispatch(action);
};




/** WEBPACK FOOTER **
 ** ./src/shared_states/Dispatcher.js
 **/